import type { NotifiableError } from '@bugsnag/js';

import { crashReporterInterface } from 'app-components/utils/core';

import { bugsnagBreadcrumb, bugsnagNotify } from 'utils/core/bugsnag';

// implement shared interfaces
crashReporterInterface.crashReporterInterfaceInit({
  reportError: (error, customDetails = {}, reportOverrides = {}) =>
    // Bugsnag reports any value (non-errors as InvalidError), but its typings only accept error shapes.
    bugsnagNotify(error as NotifiableError, (report) => {
      Object.assign(report, reportOverrides);
      Object.entries(customDetails).forEach(([key, value]) => {
        if (typeof value === 'object' && value !== null) report.addMetadata(key, value);
      });
    }),
  addBreadcrumb: (name, metadata, type) => bugsnagBreadcrumb(name, metadata, type),
});
